import { Button } from '@/components/ui/Button'

interface LessonResumeDialogProps {
  lessonTitle: string
  exerciseLabel: string
  onContinue: () => void
  onStartNew: () => void
}

export function LessonResumeDialog({
  lessonTitle,
  exerciseLabel,
  onContinue,
  onStartNew,
}: LessonResumeDialogProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="lesson-resume-dialog"
    >
      <div className="w-full max-w-sm rounded-xl border bg-card p-6 shadow-2xl">
        <h2 className="text-lg font-semibold">Resume lesson?</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          You have an unfinished lesson: <span className="font-medium text-foreground">{lessonTitle}</span>
        </p>
        <p className="mt-1 text-xs text-muted-foreground">{exerciseLabel}</p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Button className="flex-1" onClick={onContinue} data-testid="lesson-resume-continue">
            Continue
          </Button>
          <Button
            className="flex-1 bg-secondary text-secondary-foreground hover:bg-secondary/80"
            onClick={onStartNew}
            data-testid="lesson-resume-start-new"
          >
            Start new
          </Button>
        </div>
      </div>
    </div>
  )
}

interface LessonExitDialogProps {
  open: boolean
  onContinue: () => void
  onLeave: () => void
}

export function LessonExitDialog({ open, onContinue, onLeave }: LessonExitDialogProps) {
  if (!open) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="lesson-exit-dialog"
    >
      <div className="w-full max-w-sm rounded-xl border bg-card p-6 shadow-2xl">
        <h2 className="text-lg font-semibold">Leave this lesson?</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Your progress is saved on this device. You can continue later from Practice.
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Button className="flex-1" onClick={onContinue} data-testid="lesson-exit-continue">
            Continue lesson
          </Button>
          <Button
            className="flex-1 bg-secondary text-secondary-foreground hover:bg-secondary/80"
            onClick={onLeave}
            data-testid="lesson-exit-leave"
          >
            Leave
          </Button>
        </div>
      </div>
    </div>
  )
}
